// Mock data for Devansh Gupta's Portfolio

export const personalInfo = {
  name: "Devansh Gupta",
  title: "Finance & Economics Student | Social Impact Leader",
  tagline: "Bocconi University student passionate about finance, leadership, and empowering 600+ students through their college journey",
  email: "guptadevansh559321@gmail.com",
  location: "Milan, Italy",
  university: "Università Bocconi",
  bio: "Currently pursuing a Bachelor in International Economics & Management at Università Bocconi, Milan. With a strong foundation in finance, accounting, and economics, I'm passionate about analyzing markets and driving business growth through strategic financial insights. Beyond academics, I lead a mentorship group of 600+ freshmen, making college applications more accessible and working directly with Bocconi's Head of International Recruitment.",
  socialLinks: {
    linkedin: "https://www.linkedin.com/in/devansh-gupta-81b306237/",
    email: "mailto:guptadevansh559321@gmail.com"
  }
};

export const experience = [
  {
    id: 0,
    title: "Strategy & Market Development Intern",
    organization: "Housy S.r.l.",
    duration: "February 2026 - March 2026",
    location: "Milan, Italy",
    type: "internship",
    featured: true,
    description: "Worked directly with senior leadership on strategic analysis, financial modeling, and market expansion initiatives. Conducted structured market research and feasibility analysis for new business verticals. Built unit economics and financial projection models to assess scalability. Performed competitive landscape analysis on digital rental platforms. Designed operational frameworks to improve client acquisition efficiency.",
    achievements: [
      "Developed financial projection models for business scalability assessment",
      "Conducted competitive analysis of Milan real estate and relocation sector",
      "Contributed to strategic decision-making and pilot implementation planning"
    ]
  },
  {
    id: 1,
    title: "Head of Recruitment",
    organization: "VOYAGE, Università Bocconi",
    duration: "2025 - Present",
    type: "leadership",
    description: "Led freshman volunteer team organizing Freshers Welcome Week for 1,500+ attendees. Rebranded organization with new marketing strategy and oversaw logistics, budgeting, and coordination."
  },
  {
    id: 2,
    title: "Finance Intern",
    organization: "Magnum Finvest Services",
    duration: "May-June 2025",
    type: "internship",
    description: "Conducted analysis of Large/Mid/Small-Cap Equity Funds in India. Evaluated risk-return profiles and prepared comprehensive finance reports."
  },
  {
    id: 3,
    title: "Business Consultancy Intern",
    organization: "Riveroaks (Furniture Manufacturing)",
    duration: "2024",
    type: "internship",
    description: "Provided advisory inputs on brand positioning and modular furniture market expansion. Assisted in developing pricing strategies and financial projections for new product lines."
  },
  {
    id: 4,
    title: "Business Advisory Intern",
    organization: "Shivam Udyog (Interior Design)",
    duration: "2024",
    type: "internship",
    description: "Conducted market research on interior design trends. Analyzed cost structures and provided suggestions for optimizing project profitability."
  },
  {
    id: 5,
    title: "Vice President",
    organization: "Business Fest, Lakshmipat Singhania Academy",
    duration: "2023",
    type: "leadership",
    description: "Co-led Kolkata's biggest business fest with 600+ student participants. Coordinated event themes, workshops, and competitions."
  },
  {
    id: 6,
    title: "Team Leader",
    organization: "MEDco",
    duration: "2022-2023",
    type: "leadership",
    description: "Managed app development and business pitch projects. Developed leadership, communication, and project management skills."
  },
  {
    id: 7,
    title: "Industrial Intern",
    organization: "Graphite India Limited",
    duration: "July-August 2024",
    type: "internship",
    description: "Assisted in industrial operations and raw material documentation. Supported logistics and inventory management."
  }
];

export const education = [
  {
    id: 1,
    degree: "Bachelor in International Economics & Management (BIEM)",
    institution: "Università Bocconi",
    location: "Milan, Italy",
    duration: "September 2025 - Present",
    description: "Pursuing degree at one of Europe's top business schools, focusing on finance and international markets."
  },
  {
    id: 2,
    degree: "CBSE Grade 12",
    institution: "Lakshmipat Singhania Academy",
    location: "Kolkata, India",
    duration: "2011 - 2025",
    subjects: "English, Business Studies, Accountancy, Economics, Financial Markets, Mathematics"
  }
];

export const skills = [
  {
    category: "Financial Analysis",
    items: ["Equity Fund Analysis", "Risk-Return Profiles", "Portfolio Evaluation", "Financial Reporting"]
  },
  {
    category: "Business Strategy",
    items: ["Market Research", "Pricing Strategies", "Business Development", "Cost Optimization"]
  },
  {
    category: "Technical Tools",
    items: ["MS Excel", "PowerPoint", "Sora", "DaVinci Resolve", "Blender", "Procreate"]
  },
  {
    category: "Leadership",
    items: ["Team Management", "Event Coordination", "Student Mentoring", "Public Speaking"]
  },
  {
    category: "Languages",
    items: ["English (Fluent)", "Hindi (Fluent)", "Bengali (Fluent)"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Hospital Bed Finder App",
    description: "Developed post-Covid app to locate vacant hospital beds nearby, helping patients find medical care quickly during emergencies.",
    technologies: ["App Development", "Healthcare Tech", "Location Services"]
  },
  {
    id: 2,
    title: "EV Charging Station Project",
    description: "Assisted in creating navigation tool for electric vehicle users to find charging stations efficiently.",
    technologies: ["Sustainability", "Navigation", "EV Infrastructure"]
  }
];

export const communityService = [
  {
    id: 1,
    organization: "HelpAge India",
    duration: "2016 - Present (7+ years)",
    role: "Fundraising Coordinator",
    description: "Spearheaded fundraising campaigns for old age homes. Built donor relationships and increased contributions significantly."
  },
  {
    id: 2,
    organization: "Jain Seva Sangh",
    duration: "2021 - Present",
    role: "Volunteer",
    description: "Volunteered in food donation drives for old age homes and thalassemia patients. Learned values of compassion, simplicity, and discipline."
  },
  {
    id: 3,
    organization: "College Application Mentorship",
    duration: "2025 - Present",
    role: "Lead Mentor",
    description: "Leading 600+ freshmen through college application process in collaboration with Bocconi's Head of International Recruitment."
  }
];

export const achievements = [
  {
    id: 1,
    title: "Led 1,500+ Attendee Event",
    description: "Successfully organized and executed Freshers Welcome Week at Università Bocconi",
    icon: "users"
  },
  {
    id: 2,
    title: "600+ Students Mentored",
    description: "Currently leading mentorship program for college applications",
    icon: "award"
  },
  {
    id: 3,
    title: "Financial Markets Certified",
    description: "Completed NSE Financial Markets Management and Advanced courses",
    icon: "certificate"
  },
  {
    id: 4,
    title: "7+ Years Social Service",
    description: "Continuous fundraising and volunteering for elderly care",
    icon: "heart"
  }
];

export const interests = [
  { name: "Movies", icon: "film" },
  { name: "Piano", icon: "music" },
  { name: "Football", icon: "football" },
  { name: "Swimming", icon: "waves" },
  { name: "AI Research", icon: "brain" },
  { name: "Crypto & NFTs", icon: "bitcoin" },
  { name: "Golf", icon: "flag" },
  { name: "Pickleball", icon: "trophy" }
];

export const certifications = [
  "Financial Markets Management (NSE)",
  "Advanced Financial Markets (NSE)",
  "Introduction to Generative AI (Intel)",
  "Strategic Finance Management (YouVah)"
];